import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Nested Theme Providers"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1 {...{
      "id": "nested-theme-providers"
    }}>{`Nested Theme Providers`}</h1>
    <p>{`While in most cases, you'll be using a `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component at the root of your application to set a site-wide theme,
nested Theme Providers are a powerful way to adjust styles contextually.`}</p>
    <p>{`For example, when building a Gatsby theme, you may want to set some base thematic values
that the user can easily override to match their site,
but keep some theme-specific styles for use only in the pages that your Gatsby theme generates.
Or, you might want to have a global theme, but adjust styles in a small section of a page to render with a dark color scheme.`}</p>
    <h2 {...{
      "id": "how-contexts-merge"
    }}>{`How contexts merge`}</h2>
    <p>{`When adding a nested Theme Provider, it will inherit the `}<inlineCode parentName="p">{`theme`}</inlineCode>{` and `}<inlineCode parentName="p">{`components`}</inlineCode>{` object from its parent.
The `}<inlineCode parentName="p">{`theme`}</inlineCode>{` object will be deeply merged with the outer context's theme.
The `}<inlineCode parentName="p">{`components`}</inlineCode>{` object will override any outer context components, but apply styling based on `}<inlineCode parentName="p">{`theme.styles`}</inlineCode>{`.
The inner Theme Provider will not create a new color mode state, but inherit this from the parent.`}</p>
    <h2 {...{
      "id": "functional-themes"
    }}>{`Functional Themes`}</h2>
    <p>{`The nested `}<inlineCode parentName="p">{`ThemeProvider`}</inlineCode>{` component can use a functional theme to avoid deep merging the objects or to control the way the two objects are merged in a more granular way.`}</p>
    <h2 {...{
      "id": "gatsby-themes"
    }}>{`Gatsby themes`}</h2>
    <p>{`When building a Gatsby theme, you should use `}<a parentName="p" {...{
        "href": "/packages/gatsby-plugin"
      }}><inlineCode parentName="a">{`gatsby-plugin-theme-ui`}</inlineCode></a>{` for parts of your theme that should be overridden or merged with other themes.
If you need to specify a Gatsby theme-specific subtheme, use a nested Theme Provider in a layout component that only renders around pages that you control.
This allows the end user to change their site-level theme without affecting custom styles you might need in your theme.
The end user can still shadow any components in your theme if they need to.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      